import AntDraggableModal from '../../utils/extend/AntDraggableModal'
import Logger from './logger/LoggerOld';

const WebUniversalLogger = (props: any) => {
    const { data, closeModal } = props;
    const { logType, queryType, queryId } = data;
    const dataEx = { ...data, logType };
    return (
        <>
            <AntDraggableModal
                title={`${logType.name ? logType.name : ''}【${queryType}${queryId ? '-' + queryId : ''}】日志`}
                open={true}
                okText='关闭'
                cancelButtonProps={{ style: { display: "none" } }}
                onOk={closeModal}
                closable={false}
                maskClosable={false}
                width={1080}
            >
                <Logger data={dataEx} />
            </AntDraggableModal>
        </>
    )
}

export default WebUniversalLogger;